import { parse, parseISO } from 'date-fns';

export function parseDate(dateValue: string | number | Date): Date {
  if (typeof dateValue === 'number') {
    return new Date(dateValue);
  }
  if (dateValue instanceof Date) {
    return dateValue;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return parse(dateValue, 'yyyy-MM-dd', new Date());
  }
  if (/^\d{4}-\d{2}-\d{2}T/.test(dateValue)) {
    return parseISO(dateValue);
  }
  if (/^[A-Za-z]{3}\s+\d{1,2},\s*\d{4}$/.test(dateValue)) {
    return parse(dateValue, 'MMM d, yyyy', new Date());
  }
  return parse(dateValue, 'yyyyMMdd', new Date());
}
